// animatedLoops/AnimatedLoopImage.jsx
//
// Renders a stock loop as an <img> whose src is a self-contained animated SVG
// data URI. Respects prefers-reduced-motion AT THE REACT LAYER: an <img>-loaded
// SVG does NOT see the host page's media queries (verified across Blink/Gecko/
// WebKit), so we swap to the static first-frame poster here instead of relying on
// a media query baked into the SVG.

import React, { useMemo } from "react";
import PropTypes from "prop-types";
import useReducedMotion from "../../hooks/useReducedMotion";
import { getLoopById, loopDataUri } from "./catalog";

const AnimatedLoopImage = ({
  loop,
  loopId,
  palette,
  animate = true,
  alt,
  style,
  ...rest
}) => {
  const reduced = useReducedMotion();
  const def = loop || getLoopById(loopId);
  const animated = Boolean(animate) && !reduced;

  const src = useMemo(
    () => (def ? loopDataUri(def, palette, { animated }) : null),
    [def, palette, animated]
  );

  if (!def) return null;

  return (
    <img
      src={src}
      alt={alt || `${def.name} — ${def.motion}`}
      draggable={false}
      style={{ display: "block", width: "100%", height: "100%", objectFit: "cover", ...style }}
      {...rest}
    />
  );
};

AnimatedLoopImage.propTypes = {
  loop: PropTypes.object,
  loopId: PropTypes.string,
  palette: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  animate: PropTypes.bool,
  alt: PropTypes.string,
  style: PropTypes.object,
};

export default AnimatedLoopImage;
